module.exports = __webpack_public_path__ + "8056012b91ce549cb263deb17a341691.pdf";